// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__RQ72k","title":"Images90_title__28Nvx","images":"Images90_images__1MfVz"};